/**
 * @lukso/up-connector
 * Universal Profile connector with draggable avatar and connection modal
 */

// Wagmi Adapter
export {
  fromWagmiConnector,
  fromWagmiConnectors,
} from '@lukso/up-modal'
export type {
  ConnectionModalView,
  ConnectModalSetup,
  ConnectModalTheme,
  WagmiConnection,
  WagmiConnector,
  WalletConnector,
} from '@lukso/up-modal/connect-modal'
export {
  ConnectModal,
  disconnect,
  getConnection,
  getWagmiSetup,
  setupConnectModal,
  wagmi,
  watchConnection,
} from '@lukso/up-modal/connect-modal'
// Backup & Restore Modals (Lit Components)
export { AccountModal } from './account-modal.js'
// Auto-setup for LUKSO products
export type { LuksoConnectorConfig } from './auto-setup.js'
export {
  EMBEDDED_WALLET_ID,
  EMBEDDED_WALLET_URL_DEV,
  EMBEDDED_WALLET_URL_PROD,
  LuksoConnector,
  setupLuksoConnector,
  UP_EXTENSION_ID,
} from './auto-setup.js'
export { createAvatar, DraggableAvatar } from './avatar.js'
export { BackupModal } from './backup-modal.js'
// Main exports
// Default export
export {
  createConnector,
  createConnector as default,
  UPConnector,
} from './connector.js'
// Enhanced popup system
export {
  ModalPopupInstance,
  WindowPopupInstance,
} from './popup-instance.js'
export { RestoreModal } from './restore-modal.js'
// Types
export type {
  AddressData,
  AvatarOptions,
  ConnectionState,
  ConnectorConfig,
  PopupInstance,
  PopupRequest,
  UIDelegate,
  WalletProvider,
} from './types.js'
// Release update
// build 2
